"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadServiceLineReplacementMethod = void 0;
var LeadServiceLineReplacementMethod;
(function (LeadServiceLineReplacementMethod) {
    LeadServiceLineReplacementMethod[LeadServiceLineReplacementMethod["Full"] = 0] = "Full";
    LeadServiceLineReplacementMethod[LeadServiceLineReplacementMethod["Partial"] = 1] = "Partial";
})(LeadServiceLineReplacementMethod = exports.LeadServiceLineReplacementMethod || (exports.LeadServiceLineReplacementMethod = {}));
//# sourceMappingURL=LeadServiceLineReplacementMethod.js.map